<template>
  <!-- <iframe
      v-if="file.type == 2"
      :src="link"
      frameborder="0"
   ></iframe> -->
  <div class="lesson-pdf" :class="isFullScreen ? 'lesson-pdf--fullscreen' : ''">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <div class="lesson-pdf__body">
      <pdf
        :style="'margin: 0 auto; width:' + currentZoom + '%'"
        @loaded="isLoading = false"
        class="lesson-pdf__content"
        :src="link"
        :page="Number(currentPage)"
        :rotate="currentAngle"
        @num-pages="pageCount = $event"
        @page-loaded="currentPage = $event"
      ></pdf>
    </div>
    <div class="lesson-pdf__controls">
      <div class="lesson-pdf__count">
        <b-field>
          <b-input
            :id="'lesson-pdf__input-' + file.id"
            @input="handleChange"
            v-model="inputPage"
            type="number"
            placeholder="1"
            :max="pageCount"
            :min="1"
          />
        </b-field>
        / {{ pageCount }}
      </div>

      <button :disabled="isLoading" @click="toggleFullScreen">
        <i class="mdi" :class="isFullScreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'"></i>
      </button>

      <button :disabled="isLoading" @click="currentAngle -= 90">
        <i class="mdi mdi-rotate-left"></i>
      </button>

      <button :disabled="isLoading" @click="currentAngle += 90">
        <i class="mdi mdi-rotate-right"></i>
      </button>

      <button :disabled="isLoading || currentZoom === 30" @click="currentZoom -= 5">
        <i class="mdi mdi-magnify-minus-outline"></i>
      </button>

      <button :disabled="isLoading || currentZoom === 150" @click="currentZoom += 5">
        <i class="mdi mdi-magnify-plus-outline"></i>
      </button>

      <button :disabled="isLoading || currentPage === 1" @click="handleChangePage('minus')">
        <i class="mdi mdi-arrow-left"></i>
      </button>

      <button :disabled="isLoading || currentPage === pageCount" @click="handleChangePage('plus')">
        <i class="mdi mdi-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  },
  props: {
    file: {
      default: () => {},
      type: Object
    },
    link: {
      default: () => '',
      type: String
    }
  },
  data() {
    return {
      isFullScreen: false,
      isLoading: true,
      currentPage: 1,
      inputPage: 1,
      currentZoom: 100,
      currentAngle: 0,
      pageCount: 0,
      pdfExample: 'https://cdn.filestackcontent.com/wcrjf9qPTCKXV3hMXDwK'
    }
  },
  methods: {
    toggleFullScreen() {
      let dbody = document.getElementById('body')
      let dhtml = document.getElementById('html')
      this.isFullScreen = !this.isFullScreen
      if (this.isFullScreen) {
        dbody.style.overflow = 'hidden'
        dhtml.style.overflow = 'hidden'
        return
      }
      dbody.style.overflow = 'unset'
      dhtml.style.overflow = 'unset'
    },
    handleChange(val) {
      let number = Number(val)
      if (number > this.pageCount || number < 1) {
        return
      }
      this.currentPage = number
    },
    handleChangePage(action) {
      if (action === 'plus') {
        this.currentPage += 1
      } else if (action === 'minus') {
        this.currentPage -= 1
      }
      this.inputPage = this.currentPage
    }
  },
  mounted() {
    document.onkeydown = (e) => {
      if (e.keyCode === 39) {
        if (this.currentPage === this.pageCount) return
        this.handleChangePage('plus')
      }
      if (e.keyCode === 37) {
        if (this.currentPage === 1) return
        this.handleChangePage('minus')
      }
      if (e.keyCode === 27 && this.isFullScreen) {
        this.toggleFullScreen()
      }
    }
  },
  beforeDestroy() {
    document.onkeydown = null
  }
}
</script>
